var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"absolute mb-2"},[_c('div',{staticClass:"bg-gray-900 p-3 top-0 left-0 rounded-lg text-white text-xs"},[_vm._t("default")],2),_c('div',{staticClass:"absolute top-1 left-3 w-3 h-3 -mt-2 rotate-45 bg-gray-900"})])
}
var staticRenderFns = []

export { render, staticRenderFns }